import React from "react";
import { motion } from "framer-motion";
import "../../assets/fonts/fonts.css";
import InfoBox from "../../components/home/InfoBox";

export default function InfoSection() {
  return (
    <motion.section
      className="h-auto py-[5vh] flex flex-col justify-center items-center w-full opacity-5 bg-slate-700"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <InfoBox
        title="Who am I, really?"
        body="I'm currently pursuing a Computer Science major and an Electrical 
        Engineering minor in the engineering school at the University of Virginia,
        but I've been tinkering with tech since I was a kid. I’m a passionate developer
        with a love for creating technology, from impactful web and mobile applications to 
        quality-of-life tools to make daily tasks less frustrating. My experience spans across 
        frontend and backend technologies, with a focus on creating intuitive, 
        high-performance user interfaces."
      />
      <InfoBox
        title="What am I working on?"
        body="Starting up school again, got my Xometry internship extended throughout
        the fall semester, so I'm definitely staying busy! Stepped away from personal
        projects for a bit to focus on my career, hoping to dip my toes back in this semester.
        You can check out more about what I'm working on in the Projects tab using the navbar."
      />
      <InfoBox
        title="Other random notes..."
        body="This website is currently undergoing a bit of a redesign, so that may explain any of 
        the rough edges that might be lying around. I'm actively implementing more features over 
        time, so feel free to come back later to see what I've added!"
      />
    </motion.section>
  );
}
